import axios from 'axios';
import qs from 'query-string';
import i18n from './i18n';

const CamSDK = window.CamSDK;
const $ = window.jQuery;
const WORKFLOW_ENGINE_API = window.AppConfig.WORKFLOW_ENGINE_API;
const API_URL = window.AppConfig.API_URL;

const supportedLanguages = ['en-US', 'es-ES', 'tl', 'ceb'];

const formLoader = context => {
	return function (err, taskFormInfo) {
		// NOSONAR
		if (err) {
			throw err;
		}
		let language = 'en-US';
		if (supportedLanguages.includes(i18n.language)) {
			language = i18n.language;
		}
		let url = `${window.location.origin}/forms/${language}/${taskFormInfo.key}`;
		axios
			.get(url)
			.then(() => {
				// eslint-disable-next-line no-new
				new CamSDK.Form({
					// NOSONAR
					client: context.CamClient,
					formUrl: url,
					taskId: context.task.id,
					containerElement: context.formContainer,
					processDefinitionId: context.processDefinitionID,
					processDefinitionKey: context.task.processDefinitionKey,
					done: formActionHandler(context, language)
				}); // NOSONAR
			})
			.catch(e => {
				console.log(e);
				url = `${window.location.origin}/forms/en-US/${taskFormInfo.key}`;
				// eslint-disable-next-line no-new
				new CamSDK.Form({
					// NOSONAR
					client: context.CamClient,
					formUrl: url,
					taskId: context.task.id,
					containerElement: context.formContainer,
					processDefinitionId: context.processDefinitionID,
					processDefinitionKey: context.task.processDefinitionKey,
					done: formActionHandler(context, 'en-US')
				}); // NOSONAR
			});
	};
};

const setVariableOneveryStep = (variableManager, back = 'false') => {
	console.log('test');
	const isUserLogedIn = !!localStorage.getItem('ACCESS_TOKEN');
	if (variableManager.variable('backBtn') && variableManager.variable('backBtn').type) {
		variableManager.variableValue('backBtn', back);
	}
	if (variableManager.variable('fLoggedIn') && variableManager.variable('fLoggedIn').type) {
		variableManager.variableValue('fLoggedIn', isUserLogedIn ? 'y' : 'n');
	}
	if (variableManager.variable('faccessToken') && variableManager.variable('faccessToken').type) {
		variableManager.variableValue('faccessToken', localStorage.getItem('ACCESS_TOKEN'));
	}
	if (variableManager.variable('fCurrentNoOfForm') && variableManager.variable('fCurrentNoOfForm').type) {
		let fCurrentNoOfForm;

		if (back === 'true') {
			fCurrentNoOfForm =
				+variableManager.variable('fCurrentNoOfForm').value > 1
					? +variableManager.variable('fCurrentNoOfForm').value - 1
					: 1;
		} else {
			fCurrentNoOfForm = +variableManager.variable('fCurrentNoOfForm').value + 1;
		}
		console.log({ fCurrentNoOfForm });
		variableManager.variableValue('fCurrentNoOfForm', fCurrentNoOfForm);
	}
};

const formActionHandler = (context, language) => {
	return function (err, camForm) {
		// NOSONAR
		if (err) {
			throw err;
		}
		let isFormProcessed = false;
		const variableManager = camForm.variableManager;
		$('#btn-submit').click(function () {
			if (isFormProcessed) {
				return;
			}
			isFormProcessed = true;
			if (camForm.isFormValid) {
				if (!camForm.isFormValid()) {
					isFormProcessed = false;
					return false;
				}
			}
			$('#btn-submit').prop('disabled', true);
			const continue_button_text = {
				'en-US': 'CONTINUE',
				'es-ES': 'SEGUIR',
				tl: 'CONTINUE',
				ceb: 'PADAYON'
			};
			$('#btn-submit').html(
				`${continue_button_text[language]} <em class="fas fa-circle-notch fa-spin continue_btn_workflow"></em>`
			);
			setVariableOneveryStep(variableManager);
			camForm.submit(function (error) {
				if (error) {
					throw error;
				}
				if (camForm.isEndProcess !== true) {
					context.load();
				}
			});
		});
		$.event.trigger({
			type: 'submit-click-applied',
			message: 'click is  added',
			time: new Date()
		});
		$('#btn-back').click(function () {
			if (isFormProcessed) {
				return;
			}
			isFormProcessed = true;
			$('#btn-back').prop('disabled', true);
			const back_button_text = {
				'en-US': 'BACK',
				'es-ES': 'VOLVER',
				tl: 'BACK',
				ceb: 'BALIK'
			};
			$('#btn-back').html(`${back_button_text[language]} <em class="fas fa-circle-notch fa-spin"></em>`);
			setVariableOneveryStep(variableManager, 'true');
			camForm.submit(function (error) {
				if (err) {
					throw error;
				}
				context.load();
			});
		});
	};
};
const initTask = async context => {
	const isUserLogedIn = !!localStorage.getItem('ACCESS_TOKEN');
	const currentQuery = qs.parse(window.location.search);
	const presetQueryVariable = {};
	const allowedQueryObject = [
		'fPrincipal',
		'fLenderFullName',
		'fLenderRelationShip',
		'fLenderCountryCode',
		'fLenderEmail',
		'fLenderPhoneNumber'
	];
	for (const key of Object.keys(currentQuery)) {
		const variable = {};
		if (allowedQueryObject.includes(key)) {
			variable.type = 'String';
			variable.value = currentQuery[key];
			presetQueryVariable[key] = variable;
		}
	}
	const processVariable = {
		backBtn: {
			type: 'String',
			value: 'false'
		},
		fMaxLoanAmount: {
			type: 'Integer',
			value: Number(context.metadata.max_amount)
		},
		fMinLoanAmount: {
			type: 'Integer',
			value: Number(context.metadata.min_amount)
		},
		fByDefaultInstallmentFactor: {
			type: 'String',
			value: Number(context.metadata.pre_field_installment_factor)
		},
		fPreFieldInstallments: {
			type: 'String',
			value: Number(context.metadata.max_pre_field_installment)
		},
		fLoggedIn: {
			type: 'String',
			value: isUserLogedIn ? 'y' : 'n'
		},
		faccessToken: {
			type: 'String',
			value: localStorage.getItem('ACCESS_TOKEN')
		},
		fMaxInterestRate: {
			type: 'Integer',
			value: Number(context.metadata.max_interest_percentage)
		},
		fMinInterestRate: {
			type: 'Integer',
			value: Number(context.metadata.min_interest_percentage)
		},
		fCurrentNoOfForm: {
			type: 'Integer',
			value: 1
		},
		API_DEFAULT: {
			type: 'String',
			value: API_URL.default
		},
		API_INVITATION: {
			type: 'String',
			value: API_URL.invitations
		},
		API_LOAN: {
			type: 'String',
			value: API_URL.loan
		},
		API_USER: {
			type: 'String',
			value: API_URL.user
		}
	};
	for (const key of Object.keys(presetQueryVariable)) {
		console.log(presetQueryVariable);
		processVariable[key] = presetQueryVariable[key];
	}
	console.log(processVariable);
	// eslint-disable-next-line new-cap
	const processDefinitionService = new context.CamClient.resource('process-definition');
	const process = await processDefinitionService.submitForm({
		id: context.processDefinitionID,
		variables: processVariable
	});
	localStorage.setItem(context.processDefinitionID, process.id);
	context.load();
};
export default class WorkFlowManager {
	constructor(processDefinitionID, containerId, metadata) {
		this.CamClient = new CamSDK.Client({
			mock: false,
			apiUri: WORKFLOW_ENGINE_API
		});
		this.metadata = metadata;
		this.processDefinitionID = processDefinitionID;
		this.formContainer = $(containerId);
	}

	task = null;
	load = async () => {
		try {
			// debugger;
			// eslint-disable-next-line new-cap
			const taskService = new this.CamClient.resource('task');
			const processDefinitionID = this.processDefinitionID;
			const executionId = localStorage.getItem(processDefinitionID);
			let tasks = null;
			if (executionId) {
				tasks = await taskService.list({
					processDefinitionId: processDefinitionID,
					executionId
				});
			}
			if (tasks && tasks.count > 0) {
				this.task = tasks._embedded.task.find(function (t) {
					return t;
				});
			}
			if (this.task) {
				taskService.form(this.task.id, formLoader(this));
				return;
			}
			await initTask(this);
		} catch (err) {
			console.log(err);
		}
	};
}
